export default __webpack_public_path__ + "img/dTUrWEKD.6d11d366.svg";